export const STONE_STATUS = {
  unverified: 'None',
  hasStones: 'validated',
  noStones: 'removed'
};

export const STONE_STATUS_TITLES = {
  [STONE_STATUS.unverified]: 'Not validated',
  [STONE_STATUS.hasStones]: 'Has stones',
  [STONE_STATUS.noStones]: 'No stones'
};
